import { render, staticRenderFns } from "./WorkStation.vue?vue&type=template&id=5dee8848&scoped=true&"
import script from "./WorkStation.vue?vue&type=script&lang=js&"
export * from "./WorkStation.vue?vue&type=script&lang=js&"
import style0 from "./WorkStation.vue?vue&type=style&index=0&id=5dee8848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee8848",
  null
  
)

export default component.exports